import { render, staticRenderFns } from "./SimPlaceholder.vue?vue&type=template&id=75f17167&scoped=true&"
import script from "./SimPlaceholder.vue?vue&type=script&lang=ts&"
export * from "./SimPlaceholder.vue?vue&type=script&lang=ts&"
import style0 from "./SimPlaceholder.vue?vue&type=style&index=0&id=75f17167&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f17167",
  null
  
)

export default component.exports